'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SettingsArrow;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = require('./style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rightArrowPath = 'M5.937 4.358L1.107.046C1.068.013 1.02-.004.972 0 .925.005.88.027.85.066l-.806.968c-.03.037-.047.087-.043.136.005.05.027.096.064.13L3.72 4.5.063 7.7c-.037.034-.06.08-.063.13-.003.05.012.1.044.136l.805.968c.03.04.075.062.123.066h.014c.043 0 .085-.016.12-.046l4.83-4.313c.04-.035.063-.086.063-.14 0-.055-.023-.107-.063-.142z'; // eslint-disable-line max-len
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SettingsArrow
 */

var leftArrowPath = 'M.063 4.358L4.893.046c.038-.033.086-.05.134-.046.048.005.093.027.124.066l.806.968c.03.037.047.087.043.136-.005.05-.027.096-.064.13L2.28 4.5l3.656 3.2c.037.034.06.08.063.13.003.05-.012.1-.044.136l-.805.968c-.03.04-.075.062-.123.066h-.014c-.043 0-.085-.016-.12-.046L.064 4.64C.023 4.606 0 4.555 0 4.5c0-.055.023-.107.063-.142z'; // eslint-disable-line max-len

function SettingsArrow(_ref) {
  var type = _ref.type;

  var arrowClass = type === 'right' ? '' + _style.rightArrowSvg : '' + _style.leftArrowSvg;
  var arrowPath = type === 'right' ? rightArrowPath : leftArrowPath;

  return _react2.default.createElement(
    'svg',
    { className: arrowClass, width: '6', height: '9', viewBox: '0 0 6 9' },
    _react2.default.createElement('path', { d: arrowPath })
  );
}

SettingsArrow.propTypes = {
  type: _propTypes2.default.oneOf(['right', 'left']).isRequired
};

SettingsArrow.displayName = 'SettingsArrow';
module.exports = exports['default'];